module.exports = __webpack_public_path__ + "img/Helloooo.4087173b.svg";